import { RefObjetFacture } from './ref-objet-facture.model';
import { ClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class RefQuantiteFacture {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code' },
        libelle: { key: 'libelle' },
        refObjetFacture: { key: 'refObjetFacture', converter: new (ClassConverterFactory.build(RefObjetFacture))(), optional: true }
    };

    id: number = undefined;
    code: string = undefined;
    libelle: string = undefined;
    refObjetFacture: RefObjetFacture;
}
